import { render, staticRenderFns } from "./login-success.vue?vue&type=template&id=0bee2792&"
import script from "@/model/success?vue&type=script&lang=js&"
export * from "@/model/success?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports